export const BASE_URL = "https://zv.shellcode.cloud";
export const SECRET_Key = "this is secret key"; // later store this in env and user from there
